import {
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {IModalProps, Modal} from 'components/shared';
import {FC, useState} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {TranslationKeys} from 'translations';
import {IRestaurant} from 'types';

import {Information, Reviews} from './components';

interface Props extends IModalProps {
  provider: IRestaurant;
  t: (term: TranslationKeys) => string;
  activeTab?: 'information' | 'review';
}

export const ProviderDetailsModal: FC<Props> = ({isOpen, onClose, provider, t, activeTab}) => {
  const isActiveTab = activeTab === 'information' ? 0 : 1;
  const [tabIndex, setTabIndex] = useState(isActiveTab); //this state only number type

  const handleTabsChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW="700px" maxH="90vh" minH="300px" overflow="hidden" mx={['10px', 0]}>
        <ModalHeader p="30px" display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize={['18px', '24px']} fontWeight="bold">
            {t('DETAILS')} {provider.name}
          </Heading>
          <ModalCloseButton position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody p="0" overflow="scroll">
          <Tabs index={tabIndex} isFitted variant="enclosed" borderTopRadius="16px" onChange={handleTabsChange}>
            <TabList borderTopRadius="20px" border="none">
              <Tab
                border="none"
                fontWeight={600}
                fontSize="16px"
                _focus={{border: 'none'}}
                _selected={{
                  bg: colors.bodyBackground,
                  border: 'none',
                }}
              >
                {t('INFORMATION')}
              </Tab>
              <Tab
                border="none"
                fontWeight={600}
                fontSize="16px"
                _focus={{border: 'none'}}
                _selected={{
                  bg: colors.bodyBackground,
                  border: 'none',
                }}
              >
                {t('REVIEW')}
              </Tab>
            </TabList>
            <TabPanels
              bg={colors.bodyBackground}
              borderTopLeftRadius={tabIndex === 1 ? '16px' : 'none'}
              borderTopRightRadius={tabIndex === 0 ? '16px' : 'none'}
            >
              <TabPanel>
                <Information provider={provider} t={t} />
              </TabPanel>
              <TabPanel display="flex" justifyContent="center" alignItems="center">
                <Reviews providerSlug={provider.slug} providerName={provider.name} t={t} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
